import MagentoClient from '../MagentoClient'

export default class GuestMagentoClient extends MagentoClient {
  setApiUrl () {
    const domain = this.domain
    const magentoQuoteId = this.quoteId
    this.apiUrl = `${domain}/rest/V1/guest-carts/${magentoQuoteId}`
  }
}
